import React, { useState } from 'react'
import { Box, Grid, TextField, MenuItem } from '@material-ui/core'
import { useStyles } from './style'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { TableOutline, Toggle } from '../../elements'
import { ONGOINGUPCOMING, HISTORY, ENROLLED } from './constant'
import { connect } from 'react-redux'
import _ from 'lodash'
import Ongoing from './Ongoing'
import History from './History'
import CalendarView from './CalendarView'

function SystemTable(props) {
  const classes = useStyles()
  const { data } = props
  const enrolled = data && data.application_status === ENROLLED
  const [view, setView] = useState('list')
  const [selectedToggle, setToggleValue] = useState(enrolled ? ONGOINGUPCOMING : HISTORY)
  const [totalEvent, setTotalEvent] = useState(0)
  const [ongoingCount, setOngoingCount] = useState(0)
  const [historyCount, setHistoryCount] = useState(0)

  const toggleValues = [
    ...(enrolled ? [{
      label: `Ongoing & Upcoming (${ongoingCount})`,
      id: ONGOINGUPCOMING,
    }] : []),
    {
      label: `History (${historyCount})`,
      id: HISTORY,
    }
  ]

  return (
    <Box py={2}>
      <div className={classes.graphHeaderWrapper}>
        <Grid container spacing={2} alignItems="center" justify="space-between">
          <Grid item md={6}>
            <span>{`Events (Total Events - ${totalEvent})`}</span>
          </Grid>
          <Grid item md={6}>
            <span className={classes.iconContainer}>
              <span className={`${classes.iconContainer} ${view === 'list' ? 'default' : classes.unselected}`} onClick={() => setView('list')}><FormatListBulletedIcon /><span className={classes.iconTitle}>List View</span></span>
              <span className={`${classes.iconContainer} ${view === 'grid' ? 'default' : classes.unselected}`} onClick={() => setView('grid')}><DateRangeIcon /><span className={classes.iconTitle}>Calendar View</span></span>
            </span>
          </Grid>
        </Grid>
      </div>
      <Box mt={2}>
        {view === 'list' ?
          <div>
            <Toggle list={toggleValues} selected={selectedToggle} onChange={setToggleValue} />
            <Box mt={2}>
              {selectedToggle === ONGOINGUPCOMING ? <Ongoing setTotal={setTotalEvent} setOngoingCount={setOngoingCount} setHistoryCount={setHistoryCount} /> : <History setTotal={setTotalEvent} setOngoingCount={setOngoingCount} setHistoryCount={setHistoryCount} />}
            </Box>
          </div> :
          <div className={classes.calendarContainer}>
            <CalendarView systemDetails={data} />
          </div>
        }
      </Box>
    </Box>
  )
}
const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, timeZone } = auth
  return { authUser, currentUser, timeZone }
}
export default connect(mapStateToProps)(SystemTable)